module.exports = __webpack_public_path__ + "71bec74d52f6d720bd7f143957735371.svg";